

export const quotes = ["I attribute my success to this: I never gave or took any excuse.", 
    "Every child is an artist. The problem is how to remain an artist once he grows up.", 
    "Everything has beauty, but not everyone can see.", 
    "I have been impressed with the urgency of doing. Knowing is not enough; we must apply. Being willing is not enough; we must do.", 
    "Whether you think you can or you think you can’t, you’re right.", 
    "Certain things catch your eye, but pursue only those that capture the heart.", 
    "There is only one way to avoid criticism: do nothing, say nothing, and be nothing.", 
    "The best time to plant a tree was 20 years ago. The second best time is now.", 
    "Believe you can and you’re halfway there.", 
    "When I was 5 years old, my mother always told me that happiness was the key to life. When I went to school, they asked me what I wanted to be when I grew up. I wrote down ‘happy’. They told me I didn’t understand the assignment, and I told them they didn’t understand life.", 
    "Start where you are. Use what you have. Do what you can.", 
    "Ask and it will be given to you; search, and you will find; knock and the door will be opened for you.", 
    "Happiness is not something readymade. It comes from your own actions.", 
    "Twenty years from now you will be more disappointed by the things that you didn’t do than by the ones you did do, so throw off the bowlines, sail away from safe harbor, catch the trade winds in your sails. Explore, Dream, Discover.", 
    "Fall seven times and stand up eight.", 
    "Life is what happens to you while you’re busy making other plans.", 
    "If you can dream it, you can achieve it.", 
    "The mind is everything. What you think you become.", 
    "When everything seems to be going against you, remember that the airplane takes off against the wind, not with it.", 
    "A person who never made a mistake never tried anything new.", 
    "Change your thoughts and you change your world.", 
    "You can’t fall if you don’t climb. But there’s no joy in living your whole life on the ground.", 
    "Go confidently in the direction of your dreams. Live the life you have imagined.", 
    "The person who says it cannot be done should not interrupt the person who is doing it.", 
    "It does not matter how slowly you go as long as you do not stop.", 
    "Build your own dreams, or someone else will hire you to build theirs.", 
    "When I let go of what I am, I become what I might be.", 
    "If you hear a voice within you say “you cannot paint,” then by all means paint and that voice will be silenced.", 
    "People often say that motivation doesn’t last. Well, neither does bathing. That’s why we recommend it daily.", 
    "Do what you can, where you are, with what you have.", 
    "Build your own dreams, or someone else will hire you to build theirs.", 
    "Whatever you can do, or dream you can, begin it. Boldness has genius, power and magic in it.", 
    "If you want to lift yourself up, lift up someone else.", 
    "Everything you’ve ever wanted is on the other side of fear.", 
    "Life is 10% what happens to me and 90% of how I react to it.", 
    "The battles that count aren’t the ones for gold medals. The struggles within yourself–the invisible battles inside all of us–that’s where it’s at.", 
    "I’ve learned that people will forget what you said, people will forget what you did, but people will never forget how you made them feel.", 
    "Eighty percent of success is showing up.", 
    "Dreaming, after all, is a form of planning.", 
    "First, have a definite, clear practical ideal; a goal, an objective. Second, have the necessary means to achieve your ends; wisdom, money, materials, and methods. Third, adjust all your means to that end.", 
    "Life shrinks or expands in proportion to one’s courage.", 
    "If the wind will not serve, take to the oars.", 
    "It’s your place in the world; it’s your life. Go on and do all you can with it, and make it the life you want to live.", 
    "I am not a product of my circumstances. I am a product of my decisions.", 
    "Dream big and dare to fail.", 
    "You become what you believe.", 
    "Either you run the day, or the day runs you.", 
    "The only person you are destined to become is the person you decide to be.", 
    "If you want your children to turn out well, spend twice as much time with them, and half as much money.", 
    "Life isn’t about getting and having, it’s about giving and being.", 
    "If you do what you’ve always done, you’ll get what you’ve always gotten.", 
    "We become what we think about.", 
    "You may be disappointed if you fail, but you are doomed if you don’t try.", 
    "Education costs money. But then so does ignorance.", 
    "Whatever the mind of man can conceive and believe, it can achieve.", 
    "Challenges are what make life interesting and overcoming them is what makes life meaningful."
    ]; 

export const authors = ["Florence Nightingale", 
    "Pablo Picasso", 
    "Confucius", 
    "Leonardo da Vinci", 
    "Henry Ford", 
    "Ancient Indian Proverb", 
    "Aristotle", 
    "Chinese Proverb", 
    "Theodore Roosevelt", 
    "John Lennon", 
    "Arthur Ashe", 
    "Jesus", 
    "Dalai Lama", 
    "Mark Twain", 
    "Japanese Proverb", 
    "John Lennon", 
    "Zig Ziglar", 
    "Buddha", 
    "Henry Ford", 
    "Albert Einstein", 
    "Norman Vincent Peale", 
    "Unknown", 
    "Henry David Thoreau", 
    "Chinese Proverb", 
    "Confucius", 
    "Farrah Gray", 
    "Lao Tzu", 
    "Vincent Van Gogh", 
    "Zig Ziglar", 
    "Teddy Roosevelt", 
    "Farrah Gray", 
    "Johann Wolfgang von Goethe", 
    "Booker T. Washington", 
    "George Addair", 
    "Charles Swindoll", 
    "Jesse Owens", 
    "Maya Angelou", 
    "Woody Allen", 
    "Gloria Steinem", 
    "Aristotle", 
    "Anais Nin", 
    "Latin Proverb", 
    "Mae Jemison", 
    "Stephen Covey", 
    "Norman Vaughan", 
    "Oprah Winfrey", 
    "Jim Rohn", 
    "Ralph Waldo Emerson", 
    "Abigail Van Buren", 
    "Kevin Kruse", 
    "Tony Robbins", 
    "Earl Nightingale", 
    "Beverly Sills", 
    "Sir Claus Moser", 
    "Napoleon Hill", 
    "Joshua J. Marine"
    ]; 
